import ReactHtmlParser from 'react-html-parser';
import styles from '../../styles/Polityka.module.scss';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';

const Subpage = ({ content, title }) => {
  const typo = title.includes('&#8211;')
    ? [{ name: title.split('&#8211;')[0] }, { name: title.split('&#8211;')[1] }]
    : [{ name: title }];
  return (
    <div className={styles.politykaPrywatnosciContainer}>
      <Breadcrumbs mainPage={true} typo={typo} />
      {content && ReactHtmlParser(content)}
    </div>
  );
};

export async function getServerSideProps(context) {
  const slug = context.params.subpage;
  const response = await fetch(
    'https://webapi.toya.net.pl/v1/tvtoya/pages?slug=' + slug,
    {
      method: 'GET',
      mode: 'cors',
      headers: { Authorization: 'Basic dHZ0b3lhOkFZVnVmVUFyR2Y3TWtFTnY=' },
    }
  );

  const data = await response.json();
  return {
    props: {
      content: data.data[0]?.content,
      title: data.data[0]?.title,
      statusCode: response.status,
    },
  };
}

export default Subpage;
